<template>
  <div id="cardPaymentConfigForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-select
        v-model="cardPaymentConfig.centerId"
        :items="cardPaymentConfig.relations.center"
        label="Center"
        item-text="name"
        item-value="id"
        :chips="true"
        deletable-chips
      ></v-select
      ><v-text-field
        v-model="cardPaymentConfig.label"
        label="Label"
        :required="false"
      />
      <v-text-field
        v-model="cardPaymentConfig.transactionKey"
        label="Transaction Key"
        :required="true"
      />
      <v-text-field
        v-model="cardPaymentConfig.apiLoginId"
        label="API ID"
        :required="false"
      />
      <v-text-field
        v-model="cardPaymentConfig.clientKey"
        label="Client Key"
        :required="true"
      />
      <v-text-field
        v-model="cardPaymentConfig.acceptjsUrl"
        label="Accept JS URL"
        :required="true"
      />

      <v-select
        :items="availableProcessors"
        v-model="cardPaymentConfig.paymentProcessor"
        label="Payment Processor"
        :required="true"
      />

      <v-radio-group v-model="cardPaymentConfig.sandbox">
        <template v-slot:label>
          <div>Is Sandbox</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="cardPaymentConfig.active">
        <template v-slot:label>
          <div>Is Active</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>


      <v-radio-group v-model="cardPaymentConfig.allowAch">
        <template v-slot:label>
          <div>Accept E-Check</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>


      <v-text-field
        v-model.number="cardPaymentConfig.defaultCCFees"
        label="Default Credit Card Fees"
        :required="false"
        placeholder="Enter a percentage, for example 3 for 3%"
      />

      <v-text-field
        v-model.number="cardPaymentConfig.defaultTaxRate"
        label="Default Tax Rate"
        :required="false"
        placeholder="Enter a percentage, for example 8.25 for 8.25%"
      />

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getCardPaymentConfig } from "@/services/cardPaymentConfig";

import { getAllLocations } from "@/services/location";

import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      availableProcessors: ["Authorized.NET", "BNG-Gateway"],
      cardPaymentConfig: {
        relations: {
          center: []
        },
        centerId: null,
        label: "",
        transactionKey: "",
        apiLoginId: "",
        clientKey: "",
        acceptjsUrl: "",
        paymentProcessor: "",
        sandbox: "",
        active: "",
        allowAch: false,
        defaultCCFees: 0.0,
        defaultTaxRate: 0.0,
      }
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("cardPaymentConfig", [
      "createCardPaymentConfig",
      "updateCardPaymentConfig"
    ]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      if (this.id) {
        let cardPaymentConfig = this.cardPaymentConfig;
        delete cardPaymentConfig.relations;

        this.updateCardPaymentConfig(cardPaymentConfig)
          .then(response => {
            console.log(response);
            this.addSuccessMessage(
              "CardPaymentConfig was updated successfully"
            );
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating CardPaymentConfig, please try again later"
            );
          });
      } else {
        let cardPaymentConfig = this.cardPaymentConfig;
        delete cardPaymentConfig.relations;

        this.createCardPaymentConfig(cardPaymentConfig)
          .then(response => {
            console.log(response);
            this.addSuccessMessage(
              "CardPaymentConfig was created successfully"
            );
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating CardPaymentConfig, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.cardPaymentConfig.id = this.id;
        getCardPaymentConfig(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(
                this.cardPaymentConfig,
                property
              )
            ) {
              this.cardPaymentConfig[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {
      const params_center = {
        page: 0,
        size: 100
      };
      getAllLocations(params_center).then(response => {
        this.cardPaymentConfig.relations.center = response.data.content;
      });
    }
  },
  components: {}
};
</script>
